export const InitialState = () => ({
    logoData: {
        logoUrl: null
    }
});